import React, { useContext, Fragment } from "react";
import PropTypes from "prop-types";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import DiseaseFundOpenCard from "./DiseaseFundOpenCard";
import DiseaseFundClosedCard from "./DiseaseFundClosedCard";
import DiseaseFundWaitListOnlyCard from "./DiseaseFundWaitListOnlyCard";
import { fundStatusColor, fundStatusLabel } from "../../helpers/fund";

import { notDiseaseFund } from "../../helpers/fund";

const DiseaseFundBanner = ({ title, data, jumpLink }) => {
  const status = data.Fund_Status.toLowerCase();

  return (
    <Fragment>
      <div className="Page-banner hasCard">
        <div className="Page-banner-titleContainer">
          <span className={`StatusTag u-mb1 StatusTag--${fundStatusColor(data, true)}`}>
            {fundStatusLabel(data)}
          </span>

          <h1 className="Page-banner-pageTitle f-pageTitle-sans u-mb1">
            {title}
          </h1>

          <p className="f-pageSubtitle c-white f-light">
            {status === "open" && (
              <Fragment>
                <Fragment>
                  {/* FIXME-799 */}
                  {/* {!data.FundCriteria.IsRenewalOnly && ( */}
                  {notDiseaseFund(data.Fund_ID) && (
                    <Fragment>
                      We are accepting applications for new and renewal
                      patients.
                    </Fragment>
                  )}

                  {!notDiseaseFund(data.Fund_ID) && (
                    <Fragment>
                      We are accepting applications for new and renewal
                      patients. If your application for assistance is approved,
                      you can begin receiving funding immediately.
                    </Fragment>
                  )}
                  {/* )} */}
                </Fragment>
                {/* FIXME-799 */}
                {/* <Fragment>
                  {data.FundCriteria.IsRenewalOnly && (
                    <Fragment>
                      We are currently accepting applications from existing
                      patients for renewal or second grants only. To apply, log
                      in to the{" "}
                      <a
                        className="c-white f-underline"
                        href="https://www.panapply.org/"
                      >
                        patient
                      </a>
                      ,{" "}
                      <a
                        className="c-white f-underline"
                        href="https://providerportal.panfoundation.org/"
                      >
                        provider
                      </a>
                      , or{" "}
                      <a
                        className="c-white f-underline"
                        href="https://pharmacyportal.panfoundation.org/"
                      >
                        pharmacist
                      </a>{" "}
                      portal or call 1-866-316-7263.
                    </Fragment>
                  )}
                </Fragment> */}
              </Fragment>
            )}
            {status === "open to wait list only" && (
              <Fragment>
                We are currently accepting applications from individuals on our
                wait list only. If you signed up for the {data.FundName} wait
                list, you received an email from PAN with the link to apply.
              </Fragment>
            )}
            {(status === "closed" ||
              status === "closed, wait list available") && (
              <Fragment>
                <Fragment>
                  We are not currently accepting applications for new or renewal
                  patients.
                </Fragment>

                {/* {data.AssistancePrograms.length > 0 && (
                  <Fragment>
                    {" "}
                    Within the last hour,{" "}
                    {data.AssistancePrograms.map((program, i) => (
                      <Fragment key={i}>
                        <a
                          className="c-white f-underline"
                          href={program.Website}
                        >
                          {program.Name}
                        </a>

                        {data.AssistancePrograms.length > 2 &&
                          i + 1 !== data.AssistancePrograms.length &&
                          ", "}

                        {i + 2 === data.AssistancePrograms.length && " and "}
                      </Fragment>
                    ))}{" "}
                    {data.AssistancePrograms.length > 1 ? "were" : "was"}{" "}
                    accepting applications.
                  </Fragment>
                )} */}
              </Fragment>
            )}
          </p>

          <a className="Page-jumpLink" href="#about" id="jump-link">
            {jumpLink}
          </a>
        </div>

        <div className="Page-banner-card">
          {/* FIXME-799 */}
          {/* {status === "open" && !data.FundCriteria.IsRenewalOnly && (
            <DiseaseFundOpenCard title={title} status={status} data={data} />
          )}
          {status === "open" && data.FundCriteria.IsRenewalOnly && (
            <DiseaseFundClosedCard data={data} />
          )} */}
          {status === "open" && (
            <DiseaseFundOpenCard title={title} status={status} data={data} />
          )}
          {(status === "closed, wait list available" ||
            status === "closed") && <DiseaseFundClosedCard data={data} />}
          {status === "open to wait list only" && (
            <DiseaseFundWaitListOnlyCard data={data} />
          )}
        </div>
      </div>
    </Fragment>
  );
};

DiseaseFundBanner.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default DiseaseFundBanner;
